import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CompleteEmailVerificationRequest,
  CompleteEmailVerificationResponse,
  CreateAccountRequest,
  JoinAccountRequest,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  RequestPasswordResetRequest,
  RequestPasswordResetResponse,
  ResetPasswordRequest,
  ResetPasswordResponse
} from '../models/auth.model';
import { ApiClientService } from './api-client.service';

export type ProfileResponse = {
  user: {
    userId: string;
    email: string;
    createdAt: string;
    updatedAt: string;
    roles: Array<{
      accountRoleId: string;
      accountId: string;
      roleName: string;
      userAccepted: boolean;
      accountAccepted: boolean;
      createdAt?: string;
      updatedAt?: string;
    }>;
    accounts: Array<{
      accountId: string;
      name: string;
      ownerId: string;
      createdAt?: string;
      updatedAt?: string;
    }>;
  };
  message?: string;
};

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  constructor(private readonly apiClient: ApiClientService) {}

  register(request: RegisterRequest): Observable<RegisterResponse> {
    return this.apiClient.post<RegisterResponse>('/auth/register', {
      ...request,
      email: this.normalizeEmail(request.email)
    });
  }

  requestPasswordReset(request: RequestPasswordResetRequest): Observable<RequestPasswordResetResponse> {
    return this.apiClient.post<RequestPasswordResetResponse>('/auth/request-password-reset', {
      ...request,
      email: this.normalizeEmail(request.email)
    });
  }

  completeEmailVerification(request: CompleteEmailVerificationRequest): Observable<CompleteEmailVerificationResponse> {
    return this.apiClient.post<CompleteEmailVerificationResponse>('/auth/verify-email', request);
  }

  resetPassword(request: ResetPasswordRequest): Observable<ResetPasswordResponse> {
    return this.apiClient.post<ResetPasswordResponse>('/auth/reset-password', request);
  }

  login(request: LoginRequest): Observable<LoginResponse> {
    return this.apiClient.post<LoginResponse>('/auth/login', {
      ...request,
      email: this.normalizeEmail(request.email)
    });
  }

  fetchProfile(): Observable<ProfileResponse> {
    return this.apiClient.get<ProfileResponse>('/auth/profile');
  }

  createAccount(request: CreateAccountRequest): Observable<unknown> {
    return this.apiClient.post('/account/create', request);
  }

  joinAccount(request: JoinAccountRequest): Observable<unknown> {
    return this.apiClient.post('/auth/join-account', request);
  }

  private normalizeEmail(email: string): string {
    return email.trim().toLowerCase();
  }
}
